import { pilotGoalStorageKey } from "web_myplann/Utils/WebViewModel";

export const readStoredPilotGoal = (): boolean => {
	try {
		return localStorage.getItem(pilotGoalStorageKey) === "true";
	} catch {
		return false;
	}
};
